import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
  selector: '[appEnterClick]' // Use this as an attribute
})
export class EnterClickDirective {
  constructor(private el: ElementRef) {}

  @HostListener('keydown.enter', ['$event'])
  onEnter(event: KeyboardEvent): void {
    event.preventDefault();
    (this.el.nativeElement as HTMLElement).click();
  }
}
